// removed by extract-text-webpack-plugin
module.exports = {"local-down":"local-down-350Eh","localDown":"local-down-350Eh","local-down-box":"local-down-box-1G0ez","localDownBox":"local-down-box-1G0ez","local-down-button":"local-down-button--LJpi","localDownButton":"local-down-button--LJpi","local-down-logo":"local-down-logo-2XLjn","localDownLogo":"local-down-logo-2XLjn","local-down-nav":"local-down-nav-3aAIH","localDownNav":"local-down-nav-3aAIH"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Down.css
// module id = 91
// module chunks = 0